// src/DocumentManagement.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// (ไอคอน)
const AddFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
);
const TableIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
  </svg>

);
const CategoryIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122" />
  </svg>

);
const TagIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6Z" />
</svg>
);


function DocumentManagement() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    navigate('/');
    return null;
  }

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8">
      <button
        onClick={() => navigate('/admin')} // (ปุ่มกลับไปหน้า Admin Hub)
        className="mb-6 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition duration-300"
      >
        &larr; กลับไปหน้า Admin Panel
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6 border-b pb-3">
        จัดการคลังความรู้ (KB Management)
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        
        {/* 1. เพิ่มเอกสารใหม่ (ย้ายมานี่) */}
        <Link 
          to="/new" 
          className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-green-600 group-hover:text-green-700">
            <AddFileIcon />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            เพิ่มเอกสารใหม่
          </h3>
          <p className="text-base text-gray-600">
            (หน้าฟอร์มกรอกข้อมูล)
          </p>
        </Link>
        
        {/* 2. ตารางเอกสารทั้งหมด (2.1)*/}
        <Link 
          to="/admin/documents/all" // (ลิงก์ไปหน้าตาราง)
          className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-blue-600 group-hover:text-blue-700">
            <TableIcon />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            ตารางเอกสารทั้งหมด
          </h3>
          <p className="text-base text-gray-600">
            (แก้ไข/ลบ/ปักหมุด เอกสารทั้งหมด)
          </p>
        </Link>
        
        {/* 3. จัดการหมวดหมู่ (2.2) - (เร็วๆ นี้) */}
        <Link 
          to="/admin/categories" // (ลิงก์ไปหน้าตาราง)
          className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-yellow-500 group-hover:text-yellow-600">
            <CategoryIcon />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            จัดการหมวดหมู่
          </h3>
          <p className="text-base text-gray-600">
            (เพิ่ม/แก้ไข/ลบ หมวดหมู่)
          </p>
        </Link>

        {/* 4. จัดการ Tags (2.3) - (เร็วๆ นี้) */}
        <Link 
          to="/admin/tags" // (ลิงก์ไปหน้าตาราง)
          className="block p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-teal-600 group-hover:text-teal-700">
            <TagIcon />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            จัดการ Tags
          </h3>
          <p className="text-base text-gray-600">
            (แก้ไข/ลบ/รวม Tags)
          </p>
        </Link>

      </div>
    </div>
  );
}

export default DocumentManagement;